<template>
  <div class="container">
    <div class="santa">
      <div class="santa__content">
         <div class="santa__head">
            <div class="santa__hat">
               <span></span>
            </div>
            <span class="santa__face"></span>
            <div class="santa__eyes">
               <span class="santa__eye"></span>
               <span class="santa__eye"></span>
            </div>
            <span class="santa__nose"></span>
            <div class="santa__beard">
               <span class="santa__moustache"></span>
            </div>
            <span class="santa__mouth"></span>

         </div>
         <div class="santa__arms">
            <div class="santa__arm">
               <span class="santa__hand"></span>
            </div>
            <div class="santa__arm">
               <span class="santa__hand"></span>
            </div>
         </div>
         <div class="santa__body">
            <span class="santa__belt"></span>
         </div>

         <div class="santa__legs">
            <span class="santa__leg"></span>
            <span class="santa__leg"></span>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  
  mounted() {
    
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

$yellow: #f1c835;
$red: #c62b39;
$red-dark: #a31d2f;
$skin: #ffdbbd;
$black: #333333;
$dark-white: #f7f0f0;
$light-gray: #dddddd;

.santa {
   $this: &;
   width: 300px;
   height: 400px;
   position: absolute;
   right: 0;
   bottom: 0;
   transform-origin: bottom right;
   transform: scale(0.12);

   &__content {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
   }

   &__head {
      width: 150px;
      height: 170px;
      position: relative;
      display: flex;
      justify-content: center;
      z-index: 1;
   }
   &__hat {
      width: 100%;
      height: 50%;
      border-radius: 100% 100% 0 0;
      background-color: $red;
      top: 0;
      position: absolute;
      display: flex;
      justify-content: center;
      z-index: 1;
      //left: 0;

      &:before,
      &:after {
         transition: all 0.2s ease;
         content: "";
         position: absolute;
      }
      &:before {
         transform: rotate(27deg);
         left: -41px;
         bottom: -14px;
         border-left: 20px solid transparent;
         border-right: 20px solid transparent;
         border-top: 60px solid $red;
      }
      &:after {
         background-color: $red;
         border-radius: 100%;
         top: -8px;
         left: -27px;
         width: 116%;
         height: 93px;
         transform: rotate(-4deg);
      }

      span {
         width: 100%;
         height: 100%;
         position: absolute;
         z-index: 2;
         display: flex;
         justify-content: center;

         &:before,
         &:after {
            transition: all 0.2s ease;
            content: "";
            position: absolute;
            background-color: $dark-white;
         }
         &:before {
            border-radius: 10px;
            bottom: -2px;
            width: 120%;
            height: 35px;
         }
         &:after {
            border-radius: 100%;
            width: 35px;
            height: 35px;
            bottom: -35px;
            left: -50px;
         }
      }
   }

   &__face {
      width: 100%;
      height: 110%;
      background-color: $skin;
      position: absolute;
      border-radius: 45%;
      top: 10%;
      //left: 5%;
   }

   &__eyes {
      width: 35%;
      height: 20%;
      z-index: 2;
      position: absolute;
      top: 50%;
      display: flex;
      align-items: center;

      &:before,
      &:after {
         transition: all 0.2s cubic-bezier(0.25, 0.1, 0.06, 1.38);
         content: "";
         position: absolute;
         background-color: rgba(white, 0.2);
         border: solid 1px gray;
         width: 35px;
         height: 10px;
         border-radius: 4px;
         bottom: -7px;
         left: -17px;
      }

      &:after {
         left: initial;
         right: -17px;
      }
   }

   &__eye {
      width: 10px;
      height: 10px;
      background-color: $black;
      border-radius: 100%;
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: eyes 4s ease infinite;

      @keyframes eyes {
         0% {
            height: 10px;
         }
         90% {
            height: 10px;
         }
         95% {
            height: 0px;
         }

         100% {
            height: 10px;
         }
      }

      &:last-child {
         left: initial;
         right: 0;
      }
   }

   &__nose {
      width: 12px;
      height: 20px;
      background-color: rgba(#dc4619, 0.15);
      border-radius: 10px;
      position: absolute;
      top: 70%;
      z-index: 2;

      &:before {
         transition: all 0.2s cubic-bezier(0.25, 0.1, 0.06, 1.38);
         content: "";
         position: absolute;
         background-color: gray;
         width: 14px;
         height: 1px;
         left: -1px;
      }
   }

   &__beard {
      width: 120%;
      height: 80%;
      border-radius: 50%;
      background-color: $dark-white;
      position: absolute;
      bottom: -26%;
      display: flex;
      justify-content: center;
      &:before {
         content: "";
         position: absolute;
         background-color: $skin;
         width: 82%;
         height: 60%;
         border-radius: 100%;
         top: -12px;
      }
   }

   &__moustache {
      position: absolute;
      width: 40%;
      height: 20px;
      top: 45%;
      display: flex;
      z-index: 2;
      filter: drop-shadow(0px 2px 0px $light-gray);

      &:before,
      &:after {
         transition: all 0.3s ease;
         content: "";
         position: absolute;
         background-color: $dark-white;
         transform-origin: top right;
         width: 55%;
         height: 100%;
         border-radius: 100% 0px;
      }

      &:after {
         border-radius: 0px 100%;
         right: 0;
         transform-origin: top left;
      }
   }
   &__mouth {
      width: 28px;
      height: 18px;
      border-radius: 2px 2px 50% 50%;
      background-color: #9f1c1c;
      position: absolute;
      bottom: 5px;
   }

   &__body {
      height: 55%;
      background-color: $red;
      position: absolute;
      width: 90%;
      top: 30%;
      border-radius: 40% 40% 30% 30%;
      &:before {
         content: "";
         position: absolute;
         background-color: $dark-white;
         width: 100%;
         height: 32px;
         bottom: 20%;
         border-radius: 10px;
         transform: scalex(1.05);
         z-index: 2;
      }
   }

   &__belt {
      width: 100%;
      height: 24px;
      background-color: $black;
      z-index: 1;
      position: absolute;
      bottom: 40%;
      display: flex;
      justify-content: center;
      align-items: center;

      &:before,
      &:after {
         content: "";
         position: absolute;
         border-radius: 4px;
      }

      &:before {
         width: 40px;
         height: 100%;
         border: solid 4px $yellow;
      }

      &:after {
         width: 24px;
         height: 4px;
         transform: translatex(16px);
         background-color: $yellow;
      }
   }

   &__arms {
      width: 90%;
      height: 110px;
      top: 15%;
      position: absolute;
      display: flex;
   }
   &__arm {
      transition: all 0.4s ease;
      width: 48px;
      height: 100%;
      background-color: $red-dark;
      position: absolute;
      transform-origin: center bottom;
      transform: rotate(-150deg);
      left: 14px;
      top: 20px;
      border-radius: 0px 0px 40px 40px;
      display: flex;
      justify-content: center;

      &:before {
         content: "";
         position: absolute;
         background-color: $dark-white;
         width: 125%;
         height: 24px;
         border-radius: 10px;
      }

      &:last-child {
         left: initial;
         right: 14px;
         top: 20px;
         transform-origin: center bottom;
         transform: rotate(30deg) rotateY(180deg);
         animation: arm 0.8s ease infinite alternate;

         @keyframes arm {
            25% {
               transform: rotate(50deg) rotateY(180deg);
            }
            50% {
               transform: rotate(30deg) rotateY(180deg);
            }
         }
      }
   }

   &__hand {
      width: 48px;
      height: 56px;
      background-color: $red;
      position: absolute;
      transform-origin: right bottom;
      left: 0px;
      top: -56px;
      border-radius: 50% 50% 0px 0px;

      &:before {
         content: "";
         position: absolute;
         background-color: $red;
         width: 16px;
         height: 32px;
         bottom: -2px;
         right: -10px;
         border-radius: 40px;
         transform: rotate(45deg);
      }
   }
   &__legs {
      width: 40%;
      height: 50px;
      bottom: 0px;
      position: absolute;
      display: flex;
   }
   &__leg {
      width: 48px;
      height: 80%;
      background-color: $red-dark;
      position: absolute;
      display: flex;
      justify-content: center;
      transform-origin: top right;
      &:before,
      &:after {
         content: "";
         position: absolute;
      }

      &:before {
         background-color: $black;
         width: 150%;
         height: 28px;
         bottom: -25%;
         right: 0;
         border-radius: 40px 0px 20px 40px;
      }
      &:after {
         background-color: $dark-white;
         width: 130%;
         height: 16px;
         border-radius: 10px;
         top: -10px;
      }

      &:last-child {
         right: 0;
         transform-origin: top left;
         &:before {
            right: initial;
            left: 0;
            border-radius: 0px 40px 40px 20px;
         }
      }
   }
   &:hover {
      #{$this} {
         &__content {
            animation: santa 0.6s ease;

            @keyframes santa {
               0% {
                  transform: translatey(0px);
               }
               50% {
                  transform: translatey(-20px);
               }

               100% {
                  transform: translatey(0px);
               }
            }
         }

         &__eyes {
            &:before,
            &:after {
               transform: translateY(-6px);
            }
         }

         &__nose {
            &:before {
               transform: translateY(-6px);
            }
         }

         &__moustache {
            &:before {
               transform: rotate(10deg);
            }
            &:after {
               transform: rotate(-10deg);
            }
         }
         &__arm {
            &:first-child {
               transform: rotate(-45deg);
            }
            &:last-child {
               animation-play-state: paused;
            }
         }

         &__hat {
            &:before {
               transform: rotate(40deg);

               left: -48px;
            }

            span {
               &:after {
                  left: -62px;
                  bottom: -30px;
               }
            }
         }

         &__leg {
            animation: leg1 0.6s ease;
            @keyframes leg1 {
               0% {
                  transform: rotate(0deg);
               }
               50% {
                  transform: rotate(20deg);
               }

               100% {
                  transform: rotate(0deg);
               }
            }

            &:last-child {
               animation: leg2 0.6s ease;
               @keyframes leg2 {
                  0% {
                     transform: rotate(0deg);
                  }
                  50% {
                     transform: rotate(-20deg);
                  }

                  100% {
                     transform: rotate(0deg);
                  }
               }
            }
         }
      }
   }
}
</style>